<div class="container-fluid" *ngIf="message">
  <div class="highlight-box">
    <p><input type="email" [(ngModel)]="userEmailAddress" class="form-control" /></p>

    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-primary"
      (click)="handleSendTestMessageClick()"
      [disabled]="sendingTestMessage || !userEmailAddress"
      icon="pi pi-envelope"
      [label]="'communications.mass-comm-message-edit.mass-comm-send.send-test-email-button' | translate | titlecase"
    ></button>
    <wl-busy [show]="sendingTestMessage"></wl-busy>
  </div>

  <div class="marginalize">
    <wl-mass-comm-message-edit-send-attachments
      [message]="message"
      [readonly]="readonly && !isResend"
    ></wl-mass-comm-message-edit-send-attachments>
  </div>

  <p *ngIf="readonly && !isResend">
    <span [hidden]="message.MessageSent">
      {{ 'communications.mass-comm-message-edit.mass-comm-send.date-and-time-to-send-label' | translate | titlecase }}
      {{ message.DateAndTimeToSend | date: 'shortDate' }} {{ message.DateAndTimeToSend | date: 'shortTime' }} {{ timezone }}
      {{ message.DateAndTimeToSend | wlTimeZoneName }}
    </span>

    <span [hidden]="!message.MessageSent">
      {{ 'communications.mass-comm-message-edit.mass-comm-send.date-and-time-actually-sent-label' | translate | titlecase }}
      {{ message.DateAndTimeActuallySent | date: 'shortDate' }} {{ message.DateAndTimeActuallySent | date: 'shortTime' }} {{ timezone }}
      {{ message.DateAndTimeActuallySent | wlTimeZoneName }}
    </span>
  </p>

  <ul class="list-unstyled">
    <li>
      <label>
        <input type="checkbox" [(ngModel)]="message.CreateContact" [disabled]="readonly && !isResend" />
        {{ 'communications.mass-comm-message-edit.mass-comm-send.create-contact-record-label' | translate | titlecase }}
      </label>
      <ul class="list-unstyled simple-indent simple-indent" [hidden]="!message.CreateContact">
        <li>
          <p>
            <select
              class="form-control-like"
              [(ngModel)]="message.ContactType"
              [required]="message.CreateContact"
              [disabled]="readonly && !isResend"
            >
              <option value="">
                {{ 'communications.mass-comm-message-edit.mass-comm-send.contact-type-prompt' | translate | titlecase }}
              </option>
              <option *ngFor="let contactType of contactTypes" [value]="contactType.ContactType">
                {{ contactType.ContactType }}
              </option>
            </select>
          </p>
        </li>
      </ul>
    </li>
    <li>
      <label [hidden]="message.EliminateDupEmails">
        <input
          type="checkbox"
          checked
          (click)="$event.preventDefault(); handleEliminateDupEmailsClick(true)"
          [disabled]="readonly && !isResend"
        />
        {{ 'communications.mass-comm-message-edit.mass-comm-send.allow-duplicate-emails-label' | translate | titlecase }}
      </label>
      <label [hidden]="!message.EliminateDupEmails">
        <input type="checkbox" (click)="$event.preventDefault(); handleEliminateDupEmailsClick(false)" [disabled]="readonly && !isResend" />
        {{ 'communications.mass-comm-message-edit.mass-comm-send.allow-duplicate-emails-label' | translate | titlecase }}
      </label>
    </li>
    <li *ngIf="!readonly || isResend">
      <label>
        <input type="radio" [(ngModel)]="message.ScheduleMode" [value]="scheduleModeOptions.Immediate" name="radiogroup" />
        {{ 'communications.mass-comm-message-edit.mass-comm-send.send-immediately-label' | translate | titlecase }}
      </label>
    </li>
    <li *ngIf="!readonly || isResend">
      <label>
        <input
          type="radio"
          [(ngModel)]="message.ScheduleMode"
          [value]="scheduleModeOptions.DelaySend"
          (click)="handleDelaySendClick()"
          name="radiogroup"
        />
        {{ 'communications.mass-comm-message-edit.mass-comm-send.delay-send-label' | translate | titlecase }}
      </label>
      <ul class="list-unstyled simple-indent simple-indent" [hidden]="message.ScheduleMode != scheduleModeOptions.DelaySend">
        <li>
          <p>
            <span class="wl-give-calendar-right-padding mr-5"><wl-date-selector [(ngModel)]="dateAndTimeToSendDate"></wl-date-selector></span>
            <wl-time-selector [(ngModel)]="dateAndTimeToSendTime" inputCssClass="form-control-like"></wl-time-selector>
            {{ message.DateAndTimeToSend | wlTimeZoneName }}
          </p>
        </li>
      </ul>
    </li>
    <ng-container *ngIf="!readonly && !isResend">
      <li>
        <label>
          <input type="radio" [(ngModel)]="message.ScheduleMode" [value]="scheduleModeOptions.Recurring" name="radiogroup" />
          {{ 'communications.mass-comm-message-edit.mass-comm-send.recurring-label' | translate | titlecase }}
        </label>
        <ul class="list-unstyled simple-indent simple-indent" [hidden]="message.ScheduleMode != scheduleModeOptions.Recurring">
          <li>
            <wl-cron-builder [(ngModel)]="message.CronExpression"></wl-cron-builder>
          </li>
          <div class="mt-10 mb-10" *ngIf="message.MessageId && message.MessageId != 0">
            <li class="light-text">
              {{ 'communications.mass-comm-message-edit.mass-comm-send.recurring-info.originally-created-on' | translate | ucfirst }}
              : <span class="light-text">{{ message.DateCreated | date: 'shortDate' }}</span>
            </li>
            <li class="light-text" *ngIf="message.LastMessageSentOn">
              {{ 'communications.mass-comm-message-edit.mass-comm-send.recurring-info.last-sent-on' | translate | ucfirst }}
              :
              <span class="light-text"
                >{{ message.LastMessageSentOn | date: 'shortDate' }} {{ message.LastMessageSentOn | date: 'shortTime' }}
                {{ message.LastMessageSentOn | wlTimeZoneAbbr }}</span
              >
            </li>
            <li class="light-text">
              {{ 'communications.mass-comm-message-edit.mass-comm-send.recurring-info.upcoming-send-date' | translate | ucfirst }}
              :
              <span class="light-text">
                {{ displayUpcomingSendDate ? message.UpcomingSendDate : (dateAndTimeToSendDate | date: 'shortDate') }}
                {{ displayUpcomingSendDate ? message.UpcomingSendDate : (dateAndTimeToSendDate | date: 'shortTime') }}
                {{ (displayUpcomingSendDate ? message.UpcomingSendDate : dateAndTimeToSendDate) | wlTimeZoneAbbr }}
              </span>
            </li>
          </div>
          <li>
            <label>
              <input type="checkbox" [(ngModel)]="message.OverrideDoNotEmailFlag" [disabled]="readonly" />
              {{ 'communications.mass-comm-message-edit.mass-comm-send.override-dne-label' | translate }}
            </label>
          </li>
          <li>
            <label>
              <input type="checkbox" [(ngModel)]="displayEndDate" [disabled]="readonly" (ngModelChange)="endDateChanged($event)" />
              {{ 'communications.mass-comm-message-edit.mass-comm-send.stop-sending-recurring-after-date' | translate | ucfirst }}
              <span *ngIf="displayEndDate">
                <wl-date-selector [(ngModel)]="message.EndDate"></wl-date-selector>
              </span>
            </label>
          </li>
        </ul>
      </li>
    </ng-container>
    <li>
      <input type="checkbox" [ngModel]="enableUnsub" (ngModelChange)="toggleUnsub($event)" [disabled]="readonly && !isResend" />
      <span class="ml-5">{{ 'communications.mass-comm-message-edit.mass-comm-send.unsub-email' | translate | titlecase }}</span>
      <ul class="list-unstyled simple-indent simple-indent" [hidden]="!enableUnsub">
        <li>
          <div class="mt-5 ml-5 w-33">
            <input
              type="text"
              [(ngModel)]="message.UnsubscribeEmailAddress"
              class="form-control"
              [disabled]="readonly && !isResend"
              [required]="enableUnsub"
            />
            <div>{{ 'communications.mass-comm-message-edit.mass-comm-send.unsub-email-helper-text' | translate }}</div>
          </div>
        </li>
      </ul>
    </li>
  </ul>

  <div *ngIf="specialFieldsInMessage?.length">
    <h4>{{ 'communications.mass-comm-message-edit.mass-comm-send.special-fields-alternate-values-title' | translate | titlecase }}</h4>
    <div class="form-horizontal">
      <div class="form-group" *ngFor="let fieldName of specialFieldsInMessage">
        <label class="control-label col-sm-3 col-lg-2">
          {{
            'communications.mass-comm-message-edit.mass-comm-send.special-fields.' + fieldName.toLowerCase() + '-label'
              | translate
              | titlecase
          }}
        </label>
        <div class="col-sm-9 col-lg-10">
          <input type="text" class="form-control" [(ngModel)]="message[fieldName]" *ngIf="!readonly" />
          <div class="form-control-static" *ngIf="readonly">{{ message[fieldName] }}</div>
        </div>
      </div>
    </div>
  </div>

  <p *ngIf="!readonly">
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-primary"
      (click)="handleSendClick()"
      [disabled]="sendingMessage"
      [hidden]="message.ScheduleMode != scheduleModeOptions.Immediate"
      icon="pi pi-envelope"
      [label]="'communications.mass-comm-message-edit.mass-comm-send.send-email-now-button' | translate | titlecase"
    ></button>
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-primary"
      (click)="handleSendClick()"
      [disabled]="sendingMessage"
      [hidden]="message.ScheduleMode != scheduleModeOptions.DelaySend"
      icon="pi pi-envelope"
      [label]="'communications.mass-comm-message-edit.mass-comm-send.send-delayed-email-button' | translate | titlecase"
    ></button>
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-primary"
      (click)="handleSendRecurringClick()"
      [disabled]="sendingMessage"
      [hidden]="message.ScheduleMode != scheduleModeOptions.Recurring"
      icon="pi pi-envelope"
      [label]="'communications.mass-comm-message-edit.mass-comm-send.send-recurring-email-button' | translate | titlecase"
    ></button>
    <wl-busy [show]="sendingMessage"></wl-busy>
  </p>
</div>
